import React from 'react';

const CircleAlertIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg"
             width={props.width ? props.width : props.size ? props.size : '24'}
             height={props.height ? props.height : props.size ? props.size : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'} strokeWidth="2" strokeLinecap="round"
             strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" x2="12" y1="8" y2="12"/>
            <line x1="12" x2="12.01" y1="16" y2="16"/>
        </svg>

    );
};

export default CircleAlertIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/CircleAlertIcon.jsx